export const formatInitials = (account, useSeparator = false) => {
	// Note we have some accounts with empty strings for last names
	const separator = useSeparator ? '.' : '';
	return `${account.pi.firstName.charAt(0)?.toUpperCase()}${
		account.pi.firstName ? separator : ''
	}${account.pi.lastName.charAt(0)?.toUpperCase()}${
		account.pi.lastName ? separator : ''
	}`;
};
